import { valueRender } from '@repo/toolkit/conditional-render'
import Badge from '@repo/ui/badge'

import { TripBookingProperties } from '../../../../lib/types/models/trip-booking/properties.trip-booking'
import { TripBookingTypes } from '../../../../lib/types/models/trip-booking/trip-booking'
import { getTranslatedName } from '../../../../lib/utils/functions/translation.functions'
import { convertTimeZone } from '../trip-folder-reservation/trip-folder-reservation-details'

interface PassengersTripBookingFilterBadgeProps {
  tripBooking: TripBookingTypes.Light
  active?: boolean

  onClick: () => void
}

const PassengersTripBookingFilterBadge = ({
  tripBooking,
  active,
  onClick
}: PassengersTripBookingFilterBadgeProps) => {
  if (tripBooking.isTakeInCharge) return null
  const details = TripBookingProperties.getTripStepDetails(tripBooking)
  // the step dates carry no time of day: the times are the steps' ones, in Paris time like the
  // dossier's Réservations block shows them by default
  const departureStep = TripBookingProperties.getStep(tripBooking, 'first', 'departureDate')
  const arrivalStep =
    TripBookingProperties.getDisplayArrivalStep(tripBooking) ??
    TripBookingProperties.getStep(tripBooking, 'last', 'arrivalDate')

  const label = [
    tripBooking.reservationNumber,
    details.departurePlace?.label,
    valueRender(departureStep?.departureTime, (time) =>
      convertTimeZone(time, 'Europe/Paris', departureStep?.departureTimeZone)
    ),
    details.arrivalPlace?.label,
    valueRender(arrivalStep?.arrivalTime, (time) =>
      convertTimeZone(time, 'Europe/Paris', arrivalStep?.arrivalTimeZone)
    ),
    getTranslatedName(tripBooking.transportMeans)
  ]
    .filter(Boolean)
    .join(' - ')

  return (
    <Badge
      text={label}
      variant={active ? 'warning' : 'white'}
      className="cursor-pointer select-none"
      onClick={onClick}
    />
  )
}

export default PassengersTripBookingFilterBadge
